import { Button } from "antd";
import React from "react";
import "./TextButton.scss";

const TextButton = ({ label, className, onClick }) => {
  return (
    <Button onClick={onClick} className={`btn-text ${className}`}>
      {label}
    </Button>
  );
};

export default TextButton;
